(function() {
    'use strict';

    angular
        .module('portalApp')
        .factory('ResultReportSearch', ResultReportSearch);

    ResultReportSearch.$inject = ['$resource'];

    function ResultReportSearch($resource) {
        var resourceUrl =  'api/_search/result-reports/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
